import React from "react";
import { Button, ButtonGroup } from "react-bootstrap";
import { Controller, UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import { PurchaseApi, PurchaseItemApi } from "../../../../../../../../../../../../services/Api/Organization/types";

interface Props {
	form: UseFormReturn<PurchaseApi>;
	watchedItems: PurchaseItemApi[];
	recalculateSummaryTaxes: (
		items: PurchaseItemApi[],
		taxGross: boolean,
		index?: number,
		val?: number,
		quantity?: string
	) => void;
}

const PurchaseFormItemsSummaryTableButtons = ({ form, watchedItems, recalculateSummaryTaxes }: Props) => {
	const {
		formState: { errors },
		register,
		getValues,
		control,
		watch,
		setValue,
	} = form;
	const { t } = useTranslation();

	const handleChangeTaxGross = (value: boolean) => {
		if (watch("tax_gross") !== value) {
			setValue("tax_gross", value, { shouldDirty: true });
			recalculateSummaryTaxes(watchedItems, value);
		}
	};

	return (
		<div className="ms-auto">
			<FormInput
				errors={errors}
				type="hidden"
				register={register}
				name="tax_gross"
				value={`${getValues().tax_gross}`}
			/>
			<Controller
				name="tax_gross"
				control={control}
				defaultValue={getValues().tax_gross}
				render={() => {
					return (
						<ButtonGroup className="ms-auto">
							<Button
								onClick={() => handleChangeTaxGross(false)}
								variant={!watch("tax_gross") ? "primary" : "outline-primary"}
							>
								{t(`enums.price.type.NET`)}
							</Button>
							<Button
								onClick={() => handleChangeTaxGross(true)}
								variant={watch("tax_gross") ? "primary" : "outline-primary"}
							>
								{t(`enums.price.type.GROSS`)}
							</Button>
						</ButtonGroup>
					);
				}}
			/>
		</div>
	);
};

export default PurchaseFormItemsSummaryTableButtons;
